/*==========
**  Password template scripts
==========*/
document.addEventListener('DOMContentLoaded', function() {
  /*=== password animations logic ===*/
  var footerContainer = document.querySelector('.password__footer');
  if ( footerContainer && footerContainer.querySelector('.frames') ) {
    var shapeSVG = footerContainer.querySelector('#Layer_1'),
        framesContainer = footerContainer.querySelector('.shape-wrapper'),
        footerContainerWidth = footerContainer.offsetWidth,
        framescontainerWidth = framesContainer.offsetWidth,
        enableshapeAnimation = (footerContainer.dataset.shapeAnimation === 'true'),
        shapeAnimationSpeed = footerContainer.dataset.shapeAnimationSpeed,
        anim = gsap.timeline();

    if (enableshapeAnimation) { // only animate shape when setting 'enableshapeAnimation' = true
      anim.set(framesContainer, { x: -framescontainerWidth });
      anim.to(framesContainer, {
        x: ( footerContainerWidth - (framescontainerWidth + ( ((footerContainerWidth / 100) - (framescontainerWidth / 100)).toFixed(0) * 20) )),
        ease: 'none',
        duration: shapeAnimationSpeed,
        onComplete: function() {
          if ( footerContainer.querySelector('.data-bubble-text-container') ) {
            if(shapeSVG) { tweenliteshape(shapeSVG, true) }
            splitBubbles(footerContainer);
          }
        }
      });
      if(shapeSVG) { tweenliteshape(shapeSVG, false) }
    } else {
      window.addEventListener('load', splitBubbles(footerContainer));
    }
  } else if ( document.querySelector('.newsletter-form-wrapper')) {
    setTimeout(() => {
      loadNewsletter();
    }, 2000);
  }

  // shape ANIMATION FUNCTIONS
  function tweenliteshape(frames, isFinished){
    var rect1 = frames.querySelector('.rect-1');
    var rect2 = frames.querySelector('.rect-2');
    var tl = new TimelineMax({ });
    var duration = shapeAnimationSpeed * 0.5;
    tl.set(rect1, { x: 0, y: -501, autoAlpha: 0, transformOrigin: "100% 50%" });
    tl.set(rect2, { x: 0, y: 0, autoAlpha: 0, transformOrigin: "100% 50%" });
    tl.to(rect1, { x: 0, y: -501, duration: 0.5, autoAlpha: 1, ease: 'none', repeat: -1, yoyo: true });
    tl.to(rect2, { x: 0, y: 0, duration: 0.5, autoAlpha: 1, ease: 'none', repeat: -1, yoyo: true,
      onRepeat: function() {
        setTimeout(function() {
          tl.kill();
        }, `${ shapeAnimationSpeed * 1000 }`);
      } 
    });
    isFinished ? tl.restart().pause() : tl.play();
  }

  // shape-BUBBLES ANIMATION FUNCTIONS
  function splitBubbles(footerContainer) {
    var quotes = footerContainer.querySelectorAll('[data-bubble-text]');
    var quotesLength = quotes.length;
    quotes.forEach((quote, i) => {
      if (i == 0 && quote.parentNode.id == i) {
        setTimeout(function() {
          quote.parentNode.classList.remove('bubble-hidden');
        }, 999);
        setTimeout(function() {
          splitText(quote);
        }, 1000)
      }
      if (quotesLength > 1) {
        setTimeout(function() {
          var parent = quote.parentNode;
          var nextEl = parent.nextElementSibling;
          if (nextEl) {
            parent.style.pointerEvents = 'none';
            nextEl.classList.remove('bubble-hidden');
            var nextElQuote = nextEl.children[0];
            splitText(nextElQuote);
            if (!nextEl.nextElementSibling) {
              nextEl.style.pointerEvents = 'none';
            }
          }
          setTimeout(function() { // Shown newsletter
            loadNewsletter();
          }, 2000)
        }, 4000);
      } else {
        setTimeout(function() { // Shown newsletter
          loadNewsletter();
        }, 2000)
      }
    });
  }

  // shape-BUBBLES__TEXT ANIMATION FUNCTIONS
  function splitText(quote) {
    var tl = new TimelineLite;
    var chars = new SplitText(quote, { type:"words,chars" }).chars;
    TweenLite.set(quote, { perspective: 200 });
    tl.staggerFrom(chars, 0.1, { bottom: 30, opacity: 0, scale: 1.5, rotationY: -25, ease: Power3.easeOut}, 0.1);
  }

  // Newsletter animation
  function loadNewsletter() {
    if (document.querySelector('.newsletter__wrapper')) {
      var newsletterContainer = document.querySelector('.newsletter-form-wrapper');
      newsletterContainer.classList.remove('inactive');
      newsletterContainer.style.opacity = 1;
      var newsletterFormTrigger = newsletterContainer.querySelector('.form__trigger-wrapper');
      var newsletterForm = newsletterContainer.querySelector('.newsletter-form');
      var triggerMarginLeft = (newsletterContainer.offsetWidth / 2) - (newsletterFormTrigger.offsetWidth / 2) - 14;
      var formMarginLeft = (newsletterContainer.offsetWidth / 2) - (newsletterForm.offsetWidth / 2);
      setTimeout(function() {
        newsletterForm.style.opacity = 1;
        TweenMax.set(newsletterForm, { width: "0%", marginLeft: formMarginLeft, transformOrigin: "100% 0%", ease: CustomEase.create("custom", "M0,0 C0,0.098 0,0.252 0.014,0.37 0.051,0.688 0.304,0.934 0.592,0.982 0.702,1 0.89,1 1,1 ") });
        TweenMax.set(newsletterFormTrigger, { width: "100%", marginLeft: triggerMarginLeft, transformOrigin: "100% 0%", ease: CustomEase.create("custom", "M0,0 C0,0.098 0,0.252 0.014,0.37 0.051,0.688 0.304,0.934 0.592,0.982 0.702,1 0.89,1 1,1 ") });
        newsletterFormTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          TweenMax.to(newsletterFormTrigger, {
            width: "0%",
            onComplete: function() {
              TweenMax.to(newsletterForm, { width: "100%", duration: 0.0 });
            }
          });
        });
      }, 500);
      window.addEventListener('resize', function() {
        newsletterForm.style.marginLeft = '';
        newsletterFormTrigger.style.marginLeft = '';
      });
    };
  }
});
